<div class="text-tertiary d-flex flex-column fs-6">
	<label class="fw-normal text-tertiary-light mb-1">
		{{ label }}
	</label>
	<ng-content></ng-content>
</div>
